import Vue from 'vue';
import VueRouter from 'vue-router';

import texto from '@/views/texto.vue';
import textoeimg from '@/views/textoeimg.vue';
import textoypdf from '@/views/textoypdf.vue';
import testcomercial from '@/views/pruebascomercial.vue';






Vue.use(VueRouter);

const routes = [
  {
    path: '/text',
    name: 'texto',
    component: texto,
    props: true,
  },
  {
    path: '/textandimage',
    name: 'textoeimagen',
    component: textoeimg,
    props: true,
  },
  {
    path: '/textandpdf',
    name: 'textoypdf',
    component: textoypdf,
    props: true,
  },
  {
    path: '/test',
    name: 'testcomercial',
    component: testcomercial,
    props: true,
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

export default router;
